import { render, staticRenderFns } from "./CancelFlowsIcon.vue?vue&type=template&id=b528e61e&"
import script from "./CancelFlowsIcon.vue?vue&type=script&lang=js&"
export * from "./CancelFlowsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports